import unitMixin from "@/mixins/unitMixin";
import {mapGetters} from "vuex";

export default {
    extends: unitMixin,
    computed: {
        ...mapGetters([
            // "getUnitsLmsgs",
            "getUnitsLmsgsByIds",
            // "getUnitsLmsgsTimeAgo",
            "getUnitsLmsgsTimeAgoByIds",
            "getUnitsLmsgsAddressByIds",

            "getUnitsOutputsById",

            "getUnitsIdsIsLmsgFullLoad",
            "isUnitsLmsgsLiteLoad",
            "isUnitsLmsgsFullLoad",
        ]),

        isUnitLmsgFullLoad() {
            return this.isUnitsLmsgsFullLoad || !!this.getUnitsIdsIsLmsgFullLoad.find(id => id == this.unitId)
        },
        isUnitLmsgLiteLoad() {
            return this.isUnitsLmsgsLiteLoad
        },
        unitLmsg() {
            return this.getUnitsLmsgsByIds[this.unitId]
        },
        unitLmsgLatLng() {
            return this.unitCoords || this.unitLmsg?.latlng
        },
        unitLmsgLatLngText() {
            let LatLng = this.unitLmsgLatLng || {}
            return (LatLng?.lat && LatLng?.lng) ? `lat: ${LatLng.lat}, lng: ${LatLng.lng}` : ''
        },
        unitLmsgStatus(){
            return this.unitLmsg?.status || {}
        },
        // isParked(){
        //     return this.unitLmsg?.status?.isParked
        // },
        // isMoving(){
        //     return this.unitLmsg?.status?.isMoving
        // },
        unitSpeed(){
            let speed = this.unitLmsg?.speed
            return (speed > 0 || speed === 0) ? Math.round(speed) : ''
        },
        unitLmsgSats(){
            return this.unitLmsg?.sats || ''
        },
        unitLmsgAddress(){
            // let address = this.unitLmsg?.address
            // if (!address && this.unitLmsg?.latlng) {
            //     address = `lat: ${this.unitLmsg?.latlng.lat}, lon: ${this.unitLmsg?.latlng.lng}`
            //     //lmsg = {...lmsg, address}
            // }
            // return address || ''
            return this.getUnitsLmsgsAddressByIds[this.unitId]
        },
        unitLmsgSensors(){
            return this.unitLmsg?.sensors || {}
        },
        unitLmsgOBDSensors(){
            return this.unitLmsg?.obd || {}
        },
        unitLmsgVisibleSensorsNames(){
            return Object.keys(this.unitLmsgSensors)
                .filter(s => this.unitLmsgSensors[s] && !this.unitLmsgSensors[s]?.hidden)
        },
        unitLmsgCounters(){
            return this.unitLmsg?.counters || {}
        },
        unitLmsgTime(){
            return this.unitLmsg?.time
        },
        unitLmsgTimeAgo() {
            return this.getUnitsLmsgsTimeAgoByIds[this.unitId]?.timeAgo
        },
        unitLmsgOnlineStatus() {
            return this.getUnitsLmsgsTimeAgoByIds[this.unitId]?.onlineStatus
        },
        unitLmsgLocation() {
            return this.unitLmsgAddress || this.unitLmsgLatLngText || this.$t('text.Position is not available now')
        },

        unitOutputs() {
            let lmsg = this.unitLmsg
            return (this.unit?.outputs || []).map(o => {
                let sensor = (lmsg?.sensors || {})[o.param] || {}
                let value = sensor.value
                return {
                    name: o.name,
                    view: o.name > '' && o.param > '',
                    // value: value,
                    value: (value === null || value === undefined) ? 'null' : (value ? 'on' : 'off'),
                }
            })
        },
        unitInputs() {
            let lmsg = this.unitLmsg
            return (this.unit?.inputs || []).map(i => {
                let sensor = (lmsg?.sensors || {})[i.param] || {}
                let value = sensor.value
                return {
                    name: i.name,
                    view: i.name > '' && i.param > '',
                    // value: value,
                    value: (value === null || value === undefined) ? 'null' : (value ? 'on' : 'off'),
                }
            })
        },
    }
}